import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgGavel(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/jsx("defs", {
        children: /*#__PURE__*/jsx("path", {
          id: "gavel_svg__a",
          d: "M0 0h24v24H0V0z"
        })
      }), /*#__PURE__*/jsx("clipPath", {
        id: "gavel_svg__b",
        children: /*#__PURE__*/jsx("use", {
          xlinkHref: "#gavel_svg__a",
          overflow: "visible"
        })
      }), /*#__PURE__*/jsx("path", {
        d: "M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z",
        clipPath: "url(#gavel_svg__b)"
      })]
    })
  }));
}

export { SvgGavel as default };
